<template>
  <div class="hover-zone" :class="[positionClass]">
    <div class="drawer-content">
      <div class="drawer-title">
        <DrawerTitle :title="title"/>
        <div class="hover-button">
          <DxButton :icon="buttonIcon(position)" styling-mode="text" @click="collapseDrawer(position)"/>
        </div>
      </div>

      <div class="drawer-header" v-if="$slots['drawer-header']">
        <slot name="drawer-header"/>
      </div>

      <div class="drawer-main">
        <slot/>
      </div>

      <div class="drawer-footer">
        <slot name="drawer-footer"/>
      </div>
    </div>
  </div>
</template>

<script setup>
  import DrawerTitle from "@/components/base-components/drawer/DrawerTitle.vue";
  import { DxButton } from "devextreme-vue";
  import { computed } from "vue";
  import { storeToRefs } from "pinia";
  import { useHeaderStore } from "@/stores/headerStore.js";

  const headerStore = useHeaderStore()
  const { drawerCollapseStates } = storeToRefs(headerStore)

  const props = defineProps(['position', 'screen', 'title', 'title-icon'])
  const positionClass = computed(() => `is-${props.position}`);

  const buttonIcon = (position) => {
    if (position === 'left')  return 'chevrondoubleleft'
    if (position === 'right')  return 'chevrondoubleright'
  }

  const collapseDrawer = (position) => {
    drawerCollapseStates.value[position] ? drawerCollapseStates.value[position] = false : drawerCollapseStates.value[position] = true
  }
</script>

<style lang="scss">
  .drawer-content {
    display: flex;
    flex-direction: column;
    overflow-x: hidden;
    height: 100%;

    .dx-accordion.dx-collection {
      width: 100% !important;
    }

    .drawer-title {
      position: relative;
      text-align: center;
      padding: 0.25rem;
      border-bottom: 1px solid $gray-darkest;
    }

    .drawer-header {
      display: flex;
      justify-content: center;
      align-items: center;
      border-bottom: 1px solid $gray-darkest;
    }

    .drawer-main {
      flex: 1 1 auto;
      overflow-y: auto;
      overflow-x: hidden;
    }

    .drawer-footer {
      display: flex;
      justify-content: center;
    }

    .drawer-footer:last-child {
      margin-bottom: 0.75rem;
    }
  }

  .hover-button {
    position: absolute;
    top: 0;
    bottom: 0;
    z-index: 10;

    opacity: 0;
    transition: opacity ease-in 150ms;
    pointer-events: none;
  }

  .hover-button .dx-button {
    height: 100%;
    width: 0.5rem;
    border-width: 0;
  }

  .is-left  .hover-button { right: -6px; }
  .is-right .hover-button { left:  -6px; }

  .hover-zone:hover .hover-button,
  .drawer-title:hover .hover-button {
    opacity: 1;
    pointer-events: auto;
  }
</style>
